<app-header></app-header>
<app-sidebar *ngIf="sidebarService.isSidebarVisible | async"></app-sidebar>
<main class="bg-gray-100">
    <div class="container mx-auto px-4 md:p-0">
        <div class="py-4" *ngIf="userService.isTopBannerVisible">
            <div
                class="banner-container rounded flex flex-col md:flex-row justify-start md:justify-center items-start sm:items-center p-3 md:py-2.5 md:px-8 gap-6 md:gap-8">
                <div class="text-base flex flex-col sm:flex-row gap-2">
                    <span>Webinar: <b>Meet Your New AVANA CUSO Portal</b></span>
                    <!-- <span>Webinar: <b>Legal Action and Strategy Plan</b></span> -->
                    <span>November 5th, 2026 – 10 AM PST</span>
                    <!-- <span>December 4th, 2025 – 10 AM PT</span> -->
                </div>
                <div class="flex items-center gap-3">
                    <button class="bg-main rounded px-2 py-1">
                        <a [href]="webinarRegisterUrl" target="_blank" class="no-underline text-white">
                            Register now
                        </a>
                        <!-- <a href="https://avanacuso.com/webinar-finding-legal-counsel/#register"
                            target="_blank" class="no-underline text-white">
                            Register now
                        </a> -->
                    </button>
                    <!-- <a href="https://avanacuso.com/webinar-finding-legal-counsel/" target="_blank"
                        class="text-main no-underline">Learn more</a> -->
                </div>
            </div>
        </div>
        <p-toast [life]="5000" [preventOpenDuplicates]="true"></p-toast>
        <!-- Renders `detail` as Angular-sanitized HTML so links (e.g. a support email) are clickable.
             Only messages sent with key "html" appear here. -->
        <p-toast key="html" [life]="12000" [preventOpenDuplicates]="true">
            <ng-template let-message pTemplate="message">
                <span class="p-toast-message-icon pi pi-times-circle"></span>
                <div class="p-toast-message-text">
                    <div class="p-toast-summary">{{ message.summary }}</div>
                    <div class="p-toast-detail" [innerHTML]="message.detail"></div>
                </div>
            </ng-template>
        </p-toast>
        <router-outlet></router-outlet>
    </div>
</main>
<app-footer></app-footer>